import React, { useCallback, useEffect, useState } from 'react';

import FlareConfetti from 'components/generic/flare/FlareConfetti.component';
import ProgressLine from 'components/generic/ProgressLine.component';
import DELAY from 'constants/delay.const';
import useTip from 'hooks/useTip.hook';
import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';

import CN from './TimeOffSplashStaff.module.scss';

const USE_SIMPLE_CONFETTI = true;
const L = logger('TimeOffSplashStaff');

const TimeOffSplashStaff = ({ finished, isCompleted, color, src }) => {
  const [completed, setCompleted] = useState(0);
  const { val: isShow, yay: show, nay: hide } = useTip(false);

  // FIXME: do not use setInterval
  const screenLoad = useCallback(
    async () => {
      hide();
      setInterval(() => setCompleted(finished));
      delayed(DELAY.autohide, show);
      if (completed === finished) {
        clearInterval();
      }
    },
    [completed, finished, hide, show],
  );

  useEffect(
    () => {
      L.debug('useEffect()', { finished, completed }, completed === finished);
      screenLoad();
    },
    [completed, finished, screenLoad],
  );

  return (
    <div data-bem="TimeOffSplashStaff" className={CN.container}>
      {/* TODO: can't use alt attribute on div */}
      <div
        style={{ backgroundImage: `url(${src})` }}
        alt="HR avatar"
        className={CN.avatar}
        data-bem="TimeOffSplashStaff__avatar"
      />
      <div className={CN.progressContainer} data-bem="TimeOffSplashStaff__progressContainer">
        <ProgressLine value={completed} color={color} />
      </div>

      <div className={CN.markContainer}> {isCompleted && <>{isShow && <span className={CN.mark} />}</>}</div>
      {isCompleted && <>{isShow && USE_SIMPLE_CONFETTI && <FlareConfetti />}</>}
    </div>
  );
};

export default TimeOffSplashStaff;
